import { PluginFunction } from "vue";

interface BdoxTranslationPluginOptions {
  getTranslations: () => Record<string, string>;
}

export const BdoxTranslationPlugin: PluginFunction<
  BdoxTranslationPluginOptions
> = (Vue, options) => {
  if (!options || !options.getTranslations) {
    throw new Error("getTranslations function is required");
  }

  const { getTranslations } = options;

  Vue.prototype.$bdox = (key: string) => {
    const translations = getTranslations();
    return translations[key] || "not found: " + key;
  };
};

export function getTranslations(): Record<string, string> {
  return window.Breakdance.bdoxTranslations[window.Breakdance.builderMode];
}
